import React, { SelectHTMLAttributes } from 'react'

import theme from 'presentation/styles/theme'
import * as S from './styles'

export type SelectFieldProps = {
  onInputChange?: (value: string) => void
  label?: string
  labelColor?: keyof typeof theme.ds.colors
  labelSize?: keyof typeof theme.ds.typography.size
  labelWeight?: keyof typeof theme.ds.typography.weight
  labelIcon?: React.ReactNode
  onLabelIconClick?: () => void
  initialValue?: string
  disabled?: boolean
  error?: string | false | string[]
  items?: {
    value: string | ReadonlyArray<string> | number
    label: string
    selected?: boolean
  }[]
  bgColor?: keyof typeof theme.ds.colors
  placeholder?: string
  labelOverlapping?: boolean
  radius?: keyof typeof theme.ds.typography.border.radius
} & SelectHTMLAttributes<HTMLSelectElement>

export default function SelectFieldNew({
  onInputChange,
  label,
  labelColor = 'neutral900',
  labelSize = 'small',
  labelWeight = 'normal',
  labelIcon,
  bgColor = 'white',
  onLabelIconClick,
  required = false,
  disabled = false,
  error,
  name,
  style,
  items,
  placeholder = 'Selecionar',
  labelOverlapping = false,
  radius = 'xsmall',
  ...props
}: SelectFieldProps) {
  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.currentTarget.value
    !!onInputChange && onInputChange(newValue)
    !!props.onChange && props.onChange(e)
  }

  const labelIconClick = () => {
    !!onLabelIconClick && onLabelIconClick()
  }

  return (
    <S.Wrapper style={style} disabled={disabled} error={!!error}>
      {(!!label || !!labelIcon) && (
        <S.LabelWrapper>
          {!!label && (
            <S.Label
              htmlFor={name}
              labelSize={labelSize}
              labelWeight={labelWeight}
              labelColor={labelColor}
              labelOverlapping={labelOverlapping}
            >
              {label}
              {required ? <S.Asterisk>*</S.Asterisk> : ''}
            </S.Label>
          )}
          {!!labelIcon && (
            <S.LabelIcon onClick={labelIconClick}>{labelIcon}</S.LabelIcon>
          )}
        </S.LabelWrapper>
      )}
      <S.SelectWrapper>
        <S.Select
          onChange={onChange}
          name={name}
          disabled={disabled}
          data-testid="select"
          bgColor={bgColor}
          id={name}
          radius={radius}
          {...props}
        >
          <S.Option value="" disabled>
            {placeholder}
          </S.Option>

          {items?.map((item) => (
            <S.Option
              key={item.value + '-' + item.label}
              value={item.value}
              data-testid={`select-options-${item.value}`}
              selected={item.selected}
            >
              {item.label}
            </S.Option>
          ))}
        </S.Select>
      </S.SelectWrapper>
      {!!error && <S.Error>{error}</S.Error>}
    </S.Wrapper>
  )
}
